/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteCompetitionResponse
 */
export interface DeleteCompetitionResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DeleteCompetitionResponse
     */
    success: boolean;
}

/**
 * Check if a given object implements the DeleteCompetitionResponse interface.
 */
export function instanceOfDeleteCompetitionResponse(value: object): value is DeleteCompetitionResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    return true;
}

export function DeleteCompetitionResponseFromJSON(json: any): DeleteCompetitionResponse {
    return DeleteCompetitionResponseFromJSONTyped(json, false);
}

export function DeleteCompetitionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteCompetitionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
    };
}

export function DeleteCompetitionResponseToJSON(json: any): DeleteCompetitionResponse {
    return DeleteCompetitionResponseToJSONTyped(json, false);
}

export function DeleteCompetitionResponseToJSONTyped(value?: DeleteCompetitionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
    };
}

